/* ノベルティの設定 Start
=====================================================================*/
// noverty_config : ノベルティを設定する場合はtrue、使用しない場合はfalse
// key : コレクションのハンドルを設定。大文字・小文字に注意
// price : 小計がこの指定金額以上（税込）になるとノベルティを投下する
// variant_id : ノベルティ商品のバリエーションIDを指定。管理画面のURL末尾や商品詳細ページのソース内variantsから取得
var noverty_config = false;
var noverty_settings = {
  "test" : {"price" : 0, "variant_id" : "49296871096600"},
};
/*var noverty_settings = {
  "gp" : {"price" : 300000, "variant_id" : "49317905367320"},
  "c" : {"price" : 40000, "variant_id" : "49331054477592"},
};*/

/*  設定 end
==================================================================  */

$(function(){

  /* ギフト包装の投下処理
  =====================================================================*/

  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.Giftkit = {};

  //ギフト包装を投下
  Shopify.Cart.Giftkit.set = function(set_ids) {
    enableCartBtn(false);
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: set_ids })
    };
    fetch('/cart/update.js', request)
    .then(function(response) {
      if (!response.ok) {
        throw new Error("通信失敗");
      } else {
        console.log('ギフト包装設定');
        reRenderCart();
        // カートボタンを活性化
        enableCartBtn(true);
      }
    })
    .catch((error) => {
      console.error('ギフト包装設定Error:', error);
      alert('ギフト包装設定に失敗しました。ページを再読み込みしてください。');
      return;
    });
  }
  //ギフト包装を削除
  Shopify.Cart.Giftkit.remove = function(this_id) {
    enableCartBtn(false);
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: { [this_id]: 0 } })
    };
    fetch('/cart/update.js', request)
    .then(function(response) {
      if (!response.ok) {
        throw new Error("通信失敗");
      } else {
        console.log('ギフト包装削除');
        reRenderCart();
        // カートボタンを活性化
        enableCartBtn(true);
      }
    })
    .catch((error) => {
      console.error('ギフト包装削除Error:', error);
      alert('ギフト包装削除に失敗しました。ページを再読み込みしてください。');
      return;
    });
  }

  // 実処理
  $('.js-gift-item').on('click',function(){
    // 排他処理
    if ($(this).prop('checked')){
      // 一旦全てをクリアして再チェックする
      $('.js-gift-item').prop('checked', false);
      $(this).prop('checked', true);
    }

    var this_val = $(this).filter(':checked').val();
    var this_id = $(this).attr('id');
    var set_ids = {};
    $('.js-gift-item').each(function(){
      var each_id = $(this).attr('id');
      if($(this).prop('checked') == true) {
        //チェックがあればカート投下準備
        set_ids[each_id] = '1';
      } else {
        //チェックなしは削除準備
        set_ids[each_id] = '0';
      }
    });
    
    if (this_val == 'true') {
      Shopify.Cart.Giftkit.set(set_ids);
    } else {
      Shopify.Cart.Giftkit.remove(this_id);
    }
  });


  // ギフト以外の商品がない場合、ギフトだけでは購入できないように制御
  if($('#js-reset-cart').length) {
    resetReloadCart();
  }

  // 数量変更イベントを監視して、ボタンを非活性化
  setupQuantityChangeHandler();

  //配送希望日変更
  $(document).on("change","#deliveryDate",function(){
    updateCartAttributes("配送希望日");
  });
  //配送時間帯
  $(document).on("change","#deliveryTime",function(){
    updateCartAttributes("配送時間帯");
  });
});

$(window).on('load', function(){
  // 同梱制御
  // cartItemsCheck();

  // ノベルティセット
  setNovelty();

  // Limited商品の場合数量制限を実施
  /*var variantId; 
  var limitedIds = {};
  $('.cart-item').each(function(){
    if( $(this).hasClass('js-item-limited')){
      limitedCheck = limitedOverQuantityCheck($(this));
      if(limitedCheck) {
        // バリアントID
        variantId = $(this).find('.js-quantity__input').data('quantity-variant-id');
        limitedIds[variantId] = "1";
      }
    }
  });*/

  //Limited商品の個数がオーバーしていたらひとつに修正する
  /*if (Object.keys(limitedIds).length  === 0) {
    // 配列が空なら何もしない
    return;
  } else {
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: limitedIds })
    };
    fetch('/cart/update.js', request)
    .then(function(response) {
      if (!response.ok) {
        throw new Error("通信失敗");
      } else {
        // リロードする
        window.location.href = '/cart'
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('設定に失敗しました。ページを再読み込みしてください。');
      return;
    });
  }*/
});

// Ajax処理が完了するたびに処理
$(document).ajaxStop(function() {
  // リロードする
  location.reload(); 

  // cartItemsCheck();
});

// カート同梱制御
function cartItemsCheck() {
  // カートボタンを非活性化
  enableCartBtn(false);

  var errmsg = '';
  //フラグ設定
  var check_ok = true;
  var is_limited = false;
  var is_reserved = false;
  var is_wrapping = false;
  var is_novelty = false;
  var is_order = false;
  var is_normal = false;

  var qty_reserved = 0;
  var qty_wrapping = 0;

  // カートアイテムの精査
  $('.js-cart-item').each(function(){
    var qty = $(this).find('.js-quantity__input').val();

    if($(this).hasClass('js-item-limited')) {
      is_limited = true;
    } else if ($(this).hasClass('js-item-reserved')){
      is_reserved = true;
      qty_reserved = qty_reserved + parseInt(qty);
    } else if ($(this).hasClass('js-item-wrapping')){
      is_wrapping = true;
      qty_wrapping = qty_wrapping + parseInt(qty);
    } else if ($(this).hasClass('js-item-novelty')){
      is_novelty = true;
    } else if ($(this).hasClass('js-item-order')){
      is_order = true;
    } else {
      is_normal = true;
    }
  });

  // 限定商品は別途SKUごとの数量制御あり
  // ギフト包装は1点のみ購入可
  if( qty_wrapping > 1 ) {
    errmsg += '<li>ギフト包装は、1点のみ購入可能です。</li>';
    check_ok = false;
  }
  // 予約商品は他商品と同時購入不可
  if( is_reserved && (is_limited || is_normal || is_order ) ) {
    errmsg += '<li>予約商品は、他商品と同時購入できません。</li>';
    check_ok = false;
  }
  // オーダーは他商品と同時購入不可
  if( is_order && (is_limited || is_normal || is_reserved ) ) {
    errmsg += '<li>オーダー商品は、他商品と同時購入できません。</li>';
    check_ok = false;
  }
  // ノベルティのみの購入不可
  if( is_novelty && !is_limited && !is_normal && !is_reserved && !is_order ) {
    errmsg += '<li>ノベルティのみのご購入はできません。</li>';
    check_ok = false;
  }
  // 包装のみの購入不可（別途カートクリア処理はあるが念のため）
  if( is_wrapping && !is_limited && !is_normal && !is_reserved && !is_order ) {
    errmsg += '<li>ギフト包装のみのご購入はできません。</li>';
    check_ok = false;
  }

  // チェックアウト可能判定
  if(check_ok) {
    // メッセージ非表示・カートボタンを活性化
    $('.js-cart-error-message').hide();
    enableCartBtn(true);
  } else {
    // エラーメッセージを表示
    $('.errmsg-list').html(errmsg);
    $('.js-cart-error-message').show();
  }

}

// ノベルティ投下制御
function setNovelty() {
  var nov_ids = {};
  var is_nov_item = false;
  var is_nov_set = false;
  // ノベルティ投下制御
  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.Novelty = {};
  Shopify.Cart.Novelty.set = function(ids) {
    // カートボタン不活性
    enableCartBtn(false);
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: ids })
    };
    fetch('/cart/update.js', request)
    .then(function(response) {
      if (!response.ok) {
        throw new Error("通信失敗");
      } else {
        enableCartBtn(true);
        // リロードする
        location.reload(true); 
        //reRenderCart();
      }
    })
    .catch((error) => {
      console.error('ノベルティ設定Error:', error);
      alert('ノベルティ設定に失敗しました。ページを再読み込みしてください。');
      return;
    });
  }

  // カート内精査
  if(noverty_config) {
    for(key in noverty_settings){
      var already_in_cart = false;
      var item_class = 'js-cart-item-collection-' + key;
      var item_total_price = 0;
      var nov_variant_id = noverty_settings[key]['variant_id'];
      $('.js-cart-item').each(function(){
        // すでにカートにノベルティが入っている場合
        if($(this).find('.js-cart-item-variant-id').val() == nov_variant_id) {
          already_in_cart = true;
        }
        // コレクションが対応するとき価格を加算
        if($(this).hasClass(item_class)) {
          var line_price = $(this).find('.js-cart-item-total-price').val();
          item_total_price += parseInt(line_price);
        }
      });
      // 対象商品がある場合は条件セット
      if(item_total_price > 0) {
        is_nov_item = true;
      }
      // ノベルティが未追加のとき
      if(!already_in_cart) {
        // 設定価格以上ならノベルティ設定
        if(item_total_price >= noverty_settings[key]['price']) {
          nov_ids[nov_variant_id] = '1';
          is_nov_set = true;
        }
      } else { // ノベルティがすでにカートにある場合
        // 設定価格未満ならノベルティ削除
        if(item_total_price < noverty_settings[key]['price']) {
          nov_ids[nov_variant_id] = '0';
          is_nov_set = true;
        }
      }
    }

    //対象商品があり条件セットされていればノベルティを投下
    if(is_nov_item && is_nov_set) {
      Shopify.Cart.Novelty.set(nov_ids);
    }
  }
}

// Limited数量チェック
function limitedOverQuantityCheck(target) {
  // 数量制限個数
  var limitedQuantity = 1;
  // アイテム個数
  var itemQuantity = target.find('.js-quantity__input').val();
  parseInt(itemQuantity);

  // 制限を超えている場合
  if ( itemQuantity > limitedQuantity ) {
    return true;
  } else {
    return false;
  }
}

// カートボタン制御
function enableCartBtn(status) {
  var cartBtn = $('#checkout');
  if(status == true) {
    cartBtn.removeClass('disabled').prop('disabled', false);
  } else {
    cartBtn.addClass('disabled').prop('disabled', true);
  }
}

//cart attributes 更新処理
function updateCartAttributes(target){
  // カートボタンを非活性化
  enableCartBtn(false);

  var selected = $(`[name="attributes\[${target}\]"]`);
  var formData ={
    attributes: {
      [target]: selected.val()
    }
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: "no-store",
    body: JSON.stringify(formData)
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error("通信失敗");
    } else {
      console.log('配送日時更新済み');
      // カートボタンを活性化
      enableCartBtn(true);
    }
    return;
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('カート情報の更新に失敗しました。ページを再読み込みしてください。');
    return;
  });
}
// カート内の再レンダリング
function reRenderCart() {
  $.ajax({
    url: '/cart',
    cache: false,
    datatype: 'html',
    success: function(html) {
      // カートアイテム
      var cartItemsHtml = $(html).find('#main-cart-items').html();
      $('#main-cart-items').html(cartItemsHtml);
      // 配送関係
      var cartHaisoHtml = $(html).find('#js-haiso-area').html();
      $('#js-haiso-area').html(cartHaisoHtml);
      // 合計価格
      /*var cartTotal = $(html).find('#cart-total-price').text();
      $('#cart-total-price').html(cartTotal);*/
      
      // カート内がギフト包装・ノベルティのみの場合にカートをリセット
      var cartReset = $(html).find('#js-reset-cart').val();
      if(cartReset == 'true') {
        resetReloadCart();
      }
      // ノベルティ設定
      setNovelty();
    },
    error: function () {
      alert('カートの更新に失敗しました。ページを再読み込みしてください。');
      return false;
    }
  });
}

// カート内のリセット＆リロード
function resetReloadCart() {
  $.ajax({
    url: '/cart/clear.js',
    data: '',
    datatype: 'json',
    success: function() {
      // リセットしてページリロード
      location.reload();
    },
    error: function () {
      alert('カートの更新に失敗しました。ページを再読み込みしてください。');
      return false;
    }
  });
}

//cart attributes 更新処理
function updateCartAttributes(target){
  // カートボタンを非活性化
  enableCartBtn(false);

  var selected = $(`[name="attributes\[${target}\]"]`);
  var formData ={
    attributes: {
      [target]: selected.val()
    }
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: "no-store",
    body: JSON.stringify(formData)
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error("通信失敗");
    } else {
      // カートボタンを活性化
      enableCartBtn(true);
    }
    return;
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('カート情報の更新に失敗しました。ページを再読み込みしてください。');
    return;
  });
}

//数量変更イベントを監視して、ボタンを非活性化
function setupQuantityChangeHandler(){
  // カート内の数量入力フィールドを取得
  const quantityInputs = document.getElementsByClassName('quantity__input');
  
  if (quantityInputs.length === 0) {
    return; // 数量入力がなければ処理終了
  }
  
  // 各数量入力フィールドに対して処理を設定
  Array.from(quantityInputs).forEach(inputElement => {
    // 初期値を保存しておく
    let previousCount = inputElement.value;
  
    // ユーザーが直接数値を入力したときの変化を検知
    inputElement.addEventListener('input', () => {
      const currentCount = inputElement.value;
  
      // 値が変わったらボタンの状態を更新
      if (currentCount !== previousCount) {
        previousCount = currentCount;
        //カートボタンを非活性化
        enableCartBtn(false);
      }
    });
  
    // ボタン経由で変更された場合に備えて、初期値をdata属性として保存
    inputElement.dataset.prevCount = inputElement.value;
  });
  
  // 「＋」「－」ボタンがクリックされた場合の処理
  document.querySelectorAll('.quantity__button').forEach(button => {
    button.addEventListener('click', () => {
      // 数量の変化がDOMに反映されるタイミングに合わせるため、少し遅延
      setTimeout(() => {
        const input = button.closest('.quantity').querySelector('.quantity__input');
        const currentCount = input.value;
  
        // data属性と比較して変化があれば更新
        if (input.dataset.prevCount !== currentCount) {
          input.dataset.prevCount = currentCount;
          //カートボタンを非活性化
          enableCartBtn(false);
        }
      }, 50); // 50msの遅延で値更新を確実にキャッチ
    });
  });  
}